import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { serverUrl } from '../../Constant/Static/config';
import Loader from '../../Constant/Custom/Loader';

function CVStatus() {
    const { auth } = useContext(AuthContext);
    const storedUser = auth.user;
    const [user, setUser] = useState(null);
    const [paymentFormHtml, setPaymentFormHtml] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [csrfToken, setCsrfToken] = useState('');
    const [isWantToPay, setIsWantToPay] = useState(false);
    const [isAlreadyPaid, setIsAlreadyPaid] = useState(true);
    const navigate = useNavigate();

    const [downloading, setDownloading] = useState(false)

    const handleRedirect = () => {
        // console.log("redirect");
        navigate("/dashboard/certificate-upload");
    };

    const downloadApplication = async () => {
        if (csrfToken) {
            try {
                const userDataFromLocalStorage = auth.user;
                setDownloading(true);
                if (userDataFromLocalStorage) {
                    const response = await axios.post(
                        `${serverUrl}/api/user/doc/applicationPdf`,
                        {
                            appNo: userDataFromLocalStorage.appno,
                            email: userDataFromLocalStorage.email,
                            mobile: userDataFromLocalStorage.mobile,
                            showMarkStatus: false
                        },
                        {
                            headers: {
                                'CSRF-Token': csrfToken  // Use CSRF token
                            },
                            withCredentials: true,
                            responseType: 'blob',
                        }
                    );
                    if (response.status === 200) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", `Application - ${userDataFromLocalStorage.appno}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                    } else {
                        console.log('Error');
                        // setDefaultForm();
                    }
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            } finally {
                setLoading(false);
                setDownloading(false)
            }
        }
    };

    const initiatePayment = async () => {
        try {
            const response = await axios.post(`${serverUrl}/api/initiate-payment`,
                { appno: storedUser?.appno, community: "SC" }, // The student only Rs. 250 to be paid.So, we set the default community without considering the students community.
                {
                    headers: {
                        'CSRF-Token': csrfToken  // Use CSRF token
                    },
                    withCredentials: true
                }
            );

            setPaymentFormHtml(response.data);
            setTimeout(() => {
                const form = document.getElementById('billdesk-form');
                if (form) {
                    form.submit(); // Trigger form submission
                }
            }, 100); // Slight delay to ensure the form is rendered
            // window.location.href = `https://www.paymentgateway.com?data=${formPayload}`;
        } catch (error) {
            console.error('Error initiating payment:', error);
        }
    };


    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true  // Ensure cookies are sent
                });
                setCsrfToken(response.data.csrfToken);  // Set CSRF token
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(`${serverUrl}/api/cv/pay-check`,
                    {
                        appNo: storedUser.appno,
                        mobile: storedUser.mobile,
                        email: storedUser.email
                    },
                    {
                        withCredentials: true,
                        'X-CSRF-Token': csrfToken
                    }
                );
                if (response.status === 200) {
                    setIsWantToPay(response.data.wantToPay);
                    setIsAlreadyPaid(response.data.alreadyPaid)
                }
            } catch (error) {
                console.log(error)
            }
        }
        fetchData();
    }, [csrfToken])

    useEffect(() => {
        const checkSession = async () => {
            try {
                // console.log(storedUser);
                if (!storedUser) {
                    throw new Error('No active session found');
                }

                if (!storedUser.appno || !storedUser.mobile || !storedUser.email) {
                    throw new Error('Incomplete session data');
                }

                const dataToSend = {
                    appno: storedUser.appno,
                    mobile: storedUser.mobile,
                    email: storedUser.email
                };

                const response = await axios.post(`${serverUrl}/api/user/cvStatus`,
                    dataToSend,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': csrfToken
                        }
                    });

                if (response.status === 200 && response.data) {
                    // console.log(response.data);
                    setUser(response.data);
                } else {
                    throw new Error('Failed to load user data from the server');
                }

            } catch (error) {
                console.error('Error fetching session:', error);
                setError(error.message);
                // navigate('/login');
            } finally {
                setLoading(false);
            }
        };

        checkSession();
    }, [navigate]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }
    return (
        <div className="homePage">
            <div className="welcomeApplicant">
                {user ? (
                    <>
                        <h1>Welcome, {user.userName}!</h1>
                        <div>
                            <p>
                                <b>Application No: </b>
                                {user.appno}
                            </p>
                            <p>
                                <b>Email ID: </b>
                                {user.email}
                            </p>
                            <p>
                                <b>Date of Reg: </b>
                                {user.dateOfReg}
                            </p>
                        </div>
                    </>
                ) : (
                    <div>No user data available</div>
                )}
            </div>
            <div style={{ margin: "10px" }}>
                {/* <h3>Certificate Verification Status</h3> */}
                {!isWantToPay && (

                    <table class="responsive-table">
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: "#f4f4f4" }}>Application Status</th>
                                <th>Certificate Verification Status</th>
                                <th>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {user.cvStatus === "V"
                                        ? `Personal data verified.
                                       Marks will be verified with concern authority. Wait for further updates.
                                       Follow the Counselling schedule available in the website`
                                        : user.cvStatus === "E"
                                            ? "Your registered application is not eligible.For any enquiries contact at tnleaacgcet2025@gmail.com"
                                            : user.cvStatus === "W"
                                                ? "Few of your required certificates not found on our website.For any enquiries contact at tnleaacgcet2025@gmail.com"
                                                : "Under Certificate Verification"}
                                </td>
                                <td style={{ minWidth: "300px", maxWidth: "700px", textWrap: "wrap" }}>
                                    {user.cvStatus === "V"
                                        ? "Verified"
                                        : user.cvStatus === "E"
                                            ? "Not Eligible"
                                            : user.cvStatus === "W"
                                                ? "Certificate verification is in progress. Upload the required documents mentioned in the comment box."
                                                : "Under Processing"}
                                </td>
                                <td style={{ width: "300px", textWrap: "wrap" }}>{user.comment ? user.comment : "No Comments Provided!"}</td>
                            </tr>
                        </tbody>
                    </table>
                )
                }
                { (!isWantToPay && (user.cvStatus === 'W' || user.cvStatus === 'P')) && (
                    <div className="ProceedButton" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <button style={{ margin: "20px", textAlign: "center" }} onClick={() => handleRedirect()}>
                            Certificate Upload
                        </button>
                    </div>
                )}
                {(isWantToPay && !isAlreadyPaid) && (
                    <>
                        <h6 style={{ textAlign: 'center', fontSize: '17px', color: 'red' }}><span style={{ fontSize: '20px' }}>*</span>{`Application fees partially paid.\n Proceed with balance payment of Rs.250/-. After completing the payment, proceed with the further process of counselling, For any query contact : 9487861445`}</h6>

                        <div className="ProceedButton" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <button style={{ margin: "20px", backgroundColor: '#28a745', textAlign: "center" }} onClick={initiatePayment}>
                                Proceed to Pay
                            </button>
                        </div>
                    </>
                )}
            </div>
            <div className='ProceedButton'>
                {
                    !downloading ? (
                        <button><button onClick={downloadApplication}>Download Application</button></button>
                    ) : (
                        <p>Downloading...</p>
                    )
                }
            </div>
            {paymentFormHtml && (
                <div dangerouslySetInnerHTML={{ __html: paymentFormHtml }} />
            )}
        </div>
    );
}

export default CVStatus;